import BaseFormItem from "../BaseFormItem";
import React from "react";
import Control from "lib/common/descriptorcontrols/TimeField/label";

export class TimeFieldlabel extends BaseFormItem {
    render() {
        const {activeRecord, descriptor} = this.props;
        return <Control {...this.getPlumbingProps()}
                        value={activeRecord.get(descriptor.key)}
                        enabled={activeRecord.isFieldEnabled(descriptor.key)}
        />;
    }
}

export default TimeFieldlabel;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/TimeField/label.js